import React from 'react';
import { MessageCircle } from 'lucide-react';
import { CONTACT } from '../data/mock';
import { trackWhatsAppClick } from '../lib/analytics';

const WhatsAppFloat = () => {
  return (
    <a
      href={`https://wa.me/${CONTACT.phoneRaw.replace('+', '')}`}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackWhatsAppClick('floating_button')}
      className="whatsapp-float fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] flex items-center justify-center shadow-xl transition-all hover:scale-110"
      aria-label="WhatsApp"
    >
      <MessageCircle size={26} className="text-white" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full animate-ping opacity-50" />
    </a>
  );
};

export default WhatsAppFloat;
